module.exports = __webpack_public_path__ + "media/images/sunset-pool-deck-4da5af61.jpg";